import React, { useState } from "react";
import Error from "./Error";

const Formulario = ({ setTerminoBusqueda }) => {
  const [termino, setTermino] = useState("");
  const [error, setError] = useState(false);

  const buscarImagenes = e => {
    e.preventDefault();

    // validar
    if (termino.trim() === "") {
      setError(true);
      return;
    }

    setError(false);
    setTerminoBusqueda(termino);
  };
  return (
    <form onSubmit={buscarImagenes}>
      <div className="row">
        <div className="form-group col-md-8">
          <input
            type="text"
            className="form-control form-control-lg"
            placeholder="Busca una imagen, ejemplo: fútbol o café"
            onChange={e => setTermino(e.target.value)}
          />
        </div>

        <div className="form-group col-md-4">
          <input
            type="submit"
            value="Buscar"
            className="btn btn-lg btn-danger btn-block"
          />
        </div>
      </div>

      {error ? <Error mensaje="Agrega un término de búsqueda" /> : null}
    </form>
  );
};

export default Formulario;
